import { useState } from 'react';
import { PageHeader, Tabs } from '@/components/kit/ui';
import { EventsPanel, NoticesPanel } from '@/components/kit/panels';
import { Card } from '@/components/ui/Card';

export function CalendarPage() {
  const [tab, setTab] = useState<'events' | 'notices'>('events');
  return (
    <div>
      <PageHeader title="Calendar & notices" subtitle="School events and announcements" />
      <Tabs tabs={[{ key: 'events', label: 'Events' }, { key: 'notices', label: 'Notices' }]} value={tab} onChange={setTab} />
      {tab === 'events' ? <EventsPanel /> : <Card><NoticesPanel /></Card>}
    </div>
  );
}
